import React from "react";
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  TabContent,
  TabPane,
  Container,
  Collapse,
  Row,
  Col,
  Tab,
  Modal,
  ModalBody,
  Table,
  OverlayTrigger,
  Tooltip,
  Image,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { Label } from "reactstrap";
import Moment from "moment";
import "moment/locale/id";
import DataTable from "react-data-table-component";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import GoogleMapReact from "google-map-react";

function Ringkasan() {
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = pengajuan.detailPengajuan;
  const [listUsaha, setListUsaha] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [selectedAlamat, setSelectedAlamat] = React.useState(null);
  const [modalAlamatVisible, setModalAlamatVisible] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [showModalFoto, setShowModalFoto] = React.useState(false);
  const [currentPhotos, setCurrentPhotos] = React.useState([]);
  const [modalPreviewFoto, setModalPreviewFoto] = React.useState(false);
  const [mapLocation, setMapLocation] = React.useState({
    lat: null,
    lng: null,
  });
  const itemsPerPage = 10;

  const handleFotoClick = (fotoArray) => {
    setCurrentPhotos(fotoArray); // Set foto untuk modal
    setShowModalFoto(true); // Tampilkan modal
  };

  const closeModalFoto = () => {
    setShowModalFoto(false); // Sembunyikan modal
    setCurrentPhotos([]); // Reset foto
  };

  const handleAlamatClick = (Alamat) => {
    setSelectedAlamat(Alamat);
    setModalAlamatVisible(true);
  };

  const defaultProps = {
    center: { lat: -6.2, lng: 106.8 }, // Default location (Jakarta)
    zoom: 11,
  };

  const AnyReactComponent = ({ text }) => (
    <div style={{ color: "red", fontWeight: "bold" }}>
      <i className="fas fa-map-marker-alt" style={{ fontSize: 25 }}></i> {text}
    </div>
  );
  const handleLokasiClick = (latitude, longitude) => {
    setMapLocation({ lat: latitude, lng: longitude });
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  React.useEffect(() => {
    let tmp =
      valDetail.usaha &&
      valDetail.usaha.map((val) => {
        // console.log(val, "QQQQQ");
        return {
          ...val,
          action: <></>,
        };
      });
    setListUsaha(tmp);
  }, [valDetail.usaha]);

  const AlamatUsahaModal = () => (
    <Modal
      show={modalAlamatVisible}
      onHide={() => setModalAlamatVisible(false)}
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Title
        style={{ textAlign: "center", fontWeight: "bolder", margin: 0 }}
      >
        Alamat Usaha Lengkap
        <hr></hr>
      </Modal.Title>
      {/* <Modal.Body>{selectedKeterangan}</Modal.Body> */}
      <Card.Body>{selectedAlamat}</Card.Body>
    </Modal>
  );

  const customStyles = {
    rows: {
      style: {
        height: "70px", // override the row height
      },
    },
    headRow: {
      style: {
        minHeight: 35,
        backgroundColor: "#F8F8F8",
        // fontFamily: "Poppins",
        justifyContent: "center",
      },
    },
    headCells: {
      style: {
        minHeight: 50,
        fontWeight: "bold",
        fontSize: 14,
        "&:first-child": {
          borderRight: "1px solid #ccc",
        },
      },
    },
    cells: {
      style: {
        minHeight: "70px",
        whiteSpace: "normal",
        wordBreak: "break-word",
        "&:first-child": {
          borderRight: "1px solid #ccc",
        },
      },
    },
  };

  const colPengajuan = [
    {
      name: "No",
      width: "100px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "ID Usaha",
      minWidth: "250px",
      center: true,
      selector: (row) => row.idUsaha,
    },
    {
      name: "Nama Usaha",
      minWidth: "300px",
      center: true,
      selector: (row) => row.namaUsaha,
    },
    {
      name: "Alamat Usaha",
      minWidth: "300px",
      center: true,
      selector: (row) => (row.alamatUsaha === "" ? "-" : row.alamatUsaha),
      wrap: true,
      // cell: (row) => {
      //   const maxLength = 20;
      //   const alamat = row.alamatUsaha || "-";
      //   const isLongText = alamat.length > maxLength;
      //   const truncatedKeterangan = isLongText
      //     ? `${alamat.substring(0, maxLength)}...`
      //     : alamat;

      //   return (
      //     <>
      //       <div>{truncatedKeterangan}</div>
      //       {isLongText && (
      //         <div
      //           style={{ color: "blue", cursor: "pointer" }}
      //           onClick={() => handleAlamatClick(alamat)}
      //         >
      //           Selengkapnya
      //         </div>
      //       )}
      //     </>
      //   );
      // },
    },
    {
      name: "Rating",
      minWidth: "200px",
      center: true,
      selector: (row) => row.rating,
      cell: (row) => {
        const rating = row.rating;
        const fullStars = Math.floor(rating);
        const halfStar = rating % 1 >= 0.5;
        const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

        return (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {Array(fullStars)
              .fill(0)
              .map((_, index) => (
                <FaStar key={`full-${index}`} style={{ color: "gold" }} />
              ))}
            {halfStar && <FaStarHalfAlt style={{ color: "gold" }} />}
            {Array(emptyStars)
              .fill(0)
              .map((_, index) => (
                <FaRegStar
                  key={`empty-${index}`}
                  style={{ color: "lightgray" }}
                />
              ))}
          </div>
        );
      },
    },
    {
      name: "Foto Usaha",
      minWidth: "300px",
      center: true,
      selector: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#E5594C", // Blue color for action indication
            cursor: "pointer",
            fontWeight: "bold",
            // textDecoration: "underline", // Add underline to make it look like a link
          }}
          onClick={() => handleFotoClick(row.fotoUsaha)}
        >
          <i
            class="far fa-images"
            style={{
              marginRight: "8px",
              fontSize: "18px",
            }}
          ></i>
          <span>Lihat Foto</span>
        </div>
      ),
    },
    {
      name: "Lokasi",
      minWidth: "200px",
      center: true,
      cell: (row) => {
        const [longitude, latitude] = row.location.coordinates;
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#007BFF", // Blue color for action indication
              cursor: "pointer",
              fontWeight: "bold",
              textDecoration: "underline", // Add underline to make it look like a link
            }}
            onClick={() => handleLokasiClick(latitude, longitude)}
            title={`Lihat lokasi di peta: Lat ${latitude}, Long ${longitude}`} // Tooltip for additional info
          >
            <i
              class="fas fa-map-pin"
              style={{
                marginRight: "8px",
                fontSize: "18px",
              }}
            ></i>
            <span>Lihat Lokasi</span>
          </div>
        );
      },
    },
    {
      name: "Omset Perbulan",
      minWidth: "300px",
      center: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.omsetPerBulan);
        return formattedValue;
      },
    },
    {
      name: "Pengeluaran Perbulan",
      minWidth: "300px",
      center: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.pengeluaranPerBulan);
        return formattedValue;
      },
    },
  ];

  return (
    <>
      <div
        id="previewImage"
        style={{
          display: modalPreviewFoto ? "block" : "none",
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: "9999",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={modalPreviewFoto}
          alt="Preview"
          style={{
            borderRadius: "5px",
            boxShadow: "4px 4px 8px 0px rgba(0,0,0,0.75)",
            maxHeight: "80%",
            maxWidth: "80%",
            objectFit: "contain",
            background: "transparent",
            position: "absolute",
            top: "50%", // Posisi vertikal ke tengah
            left: "50%", // Posisi horizontal ke tengah
            transform: "translate(-50%, -50%)",
          }}
        />
        <button
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            fontSize: "20px",
            cursor: "pointer",
          }}
          onClick={() => setModalPreviewFoto("")}
        >
          &times;
        </button>
      </div>

      <Modal show={showModalFoto} onHide={closeModalFoto} size="lg" centered>
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form" style={{ border: 0 }}>
            <Card.Header>
              <Card.Title
                as="h4"
                style={{
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textAlign: "center",
                }}
              >
                Foto Usaha
                <hr></hr>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              {currentPhotos.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    overflowX: "auto",
                    gap: "10px",
                    justifyContent: "center",
                  }}
                >
                  {currentPhotos.map((photo, index) => (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>Detail Gambar</Tooltip>}
                    >
                      <Image
                        key={index}
                        src={photo.url}
                        style={{
                          width: 300,
                          height: 350,
                          margin: 20,
                          cursor: "pointer",
                          objectFit: "contain",
                        }}
                        thumbnail
                        onClick={() => {
                          setModalPreviewFoto(photo.url);
                        }}
                      />
                    </OverlayTrigger>
                    // <img
                    //   key={index}
                    //   src={photo.url} // Ambil key `url`
                    //   alt={`Foto Usaha ${index + 1}`}
                    //   style={{
                    //     maxWidth: "500px",
                    //     maxHeight: "600px",
                    //     objectFit: "cover",
                    //     borderRadius: "8px",
                    //     flexShrink: 0,
                    //   }}
                    // />
                  ))}
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>
                  <p
                    style={{
                      fontWeight: "bold",
                      marginBottom: "1rem",
                      color: "red",
                    }}
                  >
                    Maaf, belum ada foto usaha saat ini.
                  </p>
                  <img
                    src={require("assets/img/sorry.jpg").default}
                    alt="Sorry"
                    style={{
                      maxWidth: "20%",
                      display: "block",
                      margin: "0 auto",
                    }}
                  />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Modal>

      <Modal show={showModal} onHide={closeModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontWeight: "bolder" }}>
            Lokasi Usaha
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ height: "400px", width: "100%" }}>
            <GoogleMapReact
              bootstrapURLKeys={{
                key: "AIzaSyAXcaz5mPbGbZs4rrFVHLTANG0NLoBEp2I",
              }}
              center={{
                lat: mapLocation.lat || defaultProps.center.lat,
                lng: mapLocation.lng || defaultProps.center.lng,
              }}
              defaultZoom={defaultProps.zoom}
            >
              {mapLocation.lat !== null && mapLocation.lng !== null && (
                <AnyReactComponent
                  lat={mapLocation.lat}
                  lng={mapLocation.lng}
                  // text="Marker"
                />
              )}
            </GoogleMapReact>
          </div>
        </Modal.Body>
      </Modal>

      <Col md="12" style={{ marginTop: 20 }}>
        <Card.Header>
          <Card.Title
            as="h4"
            style={{
              fontWeight: "bold",
              textTransform: "uppercase",
              textAlign: "center",
            }}
          >
            list usaha
            <hr></hr>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <div>
            {listUsaha.length > 0 ? (
              <DataTable
                columns={colPengajuan}
                data={listUsaha}
                // data={listPengajuan.filter(
                //   (row) =>
                //     row.id_pinjaman
                //       .toLowerCase()
                //       .includes(searchText.toLowerCase()) ||
                //     row.namaLengkap
                //       .toLowerCase()
                //       .includes(searchText.toLowerCase())
                // )}
                customStyles={customStyles}
                // paginationPerPage={totalPerHalaman}
                // progressPending={pending}
              />
            ) : (
              <div style={{ textAlign: "center" }}>
                <p
                  style={{
                    fontWeight: "bold",
                    marginBottom: "1rem",
                    color: "#617D5A",
                  }}
                >
                  Maaf, belum ada list usaha nasabah saat ini.
                </p>
                <img
                  src={require("assets/img/sorry.jpg").default}
                  alt="Sorry"
                  style={{
                    maxWidth: "20%",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              </div>
            )}
            {modalAlamatVisible && <AlamatUsahaModal />}
          </div>
        </Card.Body>
      </Col>
    </>
  );
}
export default Ringkasan;
